module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "36",
      "height": "36",
      "viewBox": "0 0 36 36"
    }
  }, [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "nonzero"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "18",
      "cy": "18",
      "r": "18",
      "fill": _vm.globalColors.primary
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#FFF",
      "d": "M25.996 24.28L24.85 11.39a.55.55 0 0 0-.547-.502h-2.355A3.952 3.952 0 0 0 18 7a3.952 3.952 0 0 0-3.949 3.888h-2.355a.548.548 0 0 0-.547.502l-1.145 12.89c0 .016-.004.032-.004.049 0 1.467 1.345 2.66 3 2.66h10c1.655 0 3-1.193 3-2.66 0-.017 0-.033-.004-.05zM18 8.104a2.848 2.848 0 0 1 2.845 2.784h-5.69A2.848 2.848 0 0 1 18 8.104zm5 17.782H13c-1.038 0-1.88-.687-1.896-1.533l1.095-12.358h1.848v1.676a.55.55 0 0 0 .552.552.55.55 0 0 0 .552-.552v-1.676h5.694v1.676a.55.55 0 0 0 .552.552.55.55 0 0 0 .552-.552v-1.676h1.848l1.1 12.358c-.017.846-.863 1.533-1.898 1.533z"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8928428","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/svg-components/productBuyCar.vue
// module id = 1166
// module chunks = 14